var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "blog-page ec-container" }, [
    _c(
      "div",
      { staticClass: "blog-content" },
      [
        _vm.blogpage.blog
          ? [
              _c("img", {
                staticClass: "back-bt",
                attrs: { src: require("./img/back.svg") },
                on: { click: _vm.back },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "content-box" },
                [
                  _c("h3", { staticClass: "blog-title" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.blogpage.blog.title) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "blog-desc" }, [
                    _c("p", { staticClass: "blog-author" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.blogpage.blog.creatorNickname) +
                          "\n                    "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "blog-date" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.formatTime(_vm.blogpage.blog.timeCreated)
                          ) +
                          "\n                    "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "content-banner-img",
                    attrs: {
                      src: _vm.blogpage.blog.headerImageUrl,
                      alt: _vm.blogpage.blog.title,
                    },
                  }),
                  _vm._v(" "),
                  _c("yqg-md-preview", {
                    attrs: { "md-text": _vm.blogpage.blog.content },
                  }),
                ],
                1
              ),
            ]
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }